// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetBboMarket (params?: {}): Promise<implicitReturnType>;
    publicGetBboMarketInteractive (params?: {}): Promise<implicitReturnType>;
    publicGetFundingData (params?: {}): Promise<implicitReturnType>;
    publicGetMarkets (params?: {}): Promise<implicitReturnType>;
    publicGetMarketsKlines (params?: {}): Promise<implicitReturnType>;
    publicGetMarketsSummary (params?: {}): Promise<implicitReturnType>;
    publicGetOrderbookMarket (params?: {}): Promise<implicitReturnType>;
    publicGetOrderbookMarketImpactPrice (params?: {}): Promise<implicitReturnType>;
    publicGetOrderbookMarketInteractive (params?: {}): Promise<implicitReturnType>;
    publicGetInsurance (params?: {}): Promise<implicitReturnType>;
    publicGetJwksJson (params?: {}): Promise<implicitReturnType>;
    publicGetOnboarding (params?: {}): Promise<implicitReturnType>;
    publicGetReferralsConfig (params?: {}): Promise<implicitReturnType>;
    publicGetStakingConfig (params?: {}): Promise<implicitReturnType>;
    publicGetSystemAnnouncements (params?: {}): Promise<implicitReturnType>;
    publicGetSystemConfig (params?: {}): Promise<implicitReturnType>;
    publicGetSystemPortfolioMarginConfig (params?: {}): Promise<implicitReturnType>;
    publicGetSystemState (params?: {}): Promise<implicitReturnType>;
    publicGetSystemTime (params?: {}): Promise<implicitReturnType>;
    publicGetSystemVolumeTiers (params?: {}): Promise<implicitReturnType>;
    publicGetTrades (params?: {}): Promise<implicitReturnType>;
    publicGetVaults (params?: {}): Promise<implicitReturnType>;
    publicGetVaultsBalance (params?: {}): Promise<implicitReturnType>;
    publicGetVaultsConfig (params?: {}): Promise<implicitReturnType>;
    publicGetVaultsHistory (params?: {}): Promise<implicitReturnType>;
    publicGetVaultsPositions (params?: {}): Promise<implicitReturnType>;
    publicGetVaultsSummary (params?: {}): Promise<implicitReturnType>;
    publicGetVaultsTransfers (params?: {}): Promise<implicitReturnType>;
    publicGetXpFeeConfig (params?: {}): Promise<implicitReturnType>;
    publicGetXpPublicTransfers (params?: {}): Promise<implicitReturnType>;
    publicGetXpTransferTransferId (params?: {}): Promise<implicitReturnType>;
    privateGetAccount (params?: {}): Promise<implicitReturnType>;
    privateGetAccountCompliance (params?: {}): Promise<implicitReturnType>;
    privateGetAccountHistory (params?: {}): Promise<implicitReturnType>;
    privateGetAccountInfo (params?: {}): Promise<implicitReturnType>;
    privateGetAccountMargin (params?: {}): Promise<implicitReturnType>;
    privateGetAccountProfile (params?: {}): Promise<implicitReturnType>;
    privateGetAccountSettings (params?: {}): Promise<implicitReturnType>;
    privateGetAccountSubaccounts (params?: {}): Promise<implicitReturnType>;
    privateGetAccountSummary (params?: {}): Promise<implicitReturnType>;
    privateGetBalance (params?: {}): Promise<implicitReturnType>;
    privateGetFills (params?: {}): Promise<implicitReturnType>;
    privateGetFundingPayments (params?: {}): Promise<implicitReturnType>;
    privateGetPositions (params?: {}): Promise<implicitReturnType>;
    privateGetTradebusts (params?: {}): Promise<implicitReturnType>;
    privateGetTransactions (params?: {}): Promise<implicitReturnType>;
    privateGetAccountKeysSubkeys (params?: {}): Promise<implicitReturnType>;
    privateGetAccountKeysSubkeysPublicKey (params?: {}): Promise<implicitReturnType>;
    privateGetAccountTokens (params?: {}): Promise<implicitReturnType>;
    privateGetAlgoOrders (params?: {}): Promise<implicitReturnType>;
    privateGetAlgoOrdersHistory (params?: {}): Promise<implicitReturnType>;
    privateGetAlgoOrdersAlgoId (params?: {}): Promise<implicitReturnType>;
    privateGetBlockTrades (params?: {}): Promise<implicitReturnType>;
    privateGetBlockTradesBlockTradeId (params?: {}): Promise<implicitReturnType>;
    privateGetBlockTradesBlockTradeIdOffers (params?: {}): Promise<implicitReturnType>;
    privateGetBlockTradesBlockTradeIdOffersOfferId (params?: {}): Promise<implicitReturnType>;
    privateGetLiquidations (params?: {}): Promise<implicitReturnType>;
    privateGetOrders (params?: {}): Promise<implicitReturnType>;
    privateGetOrdersHistory (params?: {}): Promise<implicitReturnType>;
    privateGetOrdersByClientIdClientId (params?: {}): Promise<implicitReturnType>;
    privateGetOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateGetReferralsQrCode (params?: {}): Promise<implicitReturnType>;
    privateGetReferralsSummary (params?: {}): Promise<implicitReturnType>;
    privateGetStakingHistory (params?: {}): Promise<implicitReturnType>;
    privateGetStakingSummary (params?: {}): Promise<implicitReturnType>;
    privateGetTransfers (params?: {}): Promise<implicitReturnType>;
    privateGetVaultsAccountSummary (params?: {}): Promise<implicitReturnType>;
    privateGetVaultsMine (params?: {}): Promise<implicitReturnType>;
    privateGetXpAccountBalance (params?: {}): Promise<implicitReturnType>;
    privateGetXpTransfers (params?: {}): Promise<implicitReturnType>;
    privatePostAccountCompliance (params?: {}): Promise<implicitReturnType>;
    privatePostAccountMarginMarket (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileMarketMaxSlippageMarket (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileNotifications (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileNotificationsLastSeen (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileReferralCode (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileRefreshInventory (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileSizeCurrencyDisplay (params?: {}): Promise<implicitReturnType>;
    privatePostAccountProfileUsername (params?: {}): Promise<implicitReturnType>;
    privatePostAccountReferrer (params?: {}): Promise<implicitReturnType>;
    privatePostAccountSettingsTradingValueDisplay (params?: {}): Promise<implicitReturnType>;
    privatePostAccountKeysSubkeysActivate (params?: {}): Promise<implicitReturnType>;
    privatePostAccountKeysSubkeys (params?: {}): Promise<implicitReturnType>;
    privatePostAccountTokens (params?: {}): Promise<implicitReturnType>;
    privatePostAlgoOrders (params?: {}): Promise<implicitReturnType>;
    privatePostAuth (params?: {}): Promise<implicitReturnType>;
    privatePostBlockTrades (params?: {}): Promise<implicitReturnType>;
    privatePostBlockTradesBlockTradeIdExecute (params?: {}): Promise<implicitReturnType>;
    privatePostBlockTradesBlockTradeIdOffers (params?: {}): Promise<implicitReturnType>;
    privatePostBlockTradesBlockTradeIdOffersOfferIdExecute (params?: {}): Promise<implicitReturnType>;
    privatePostOnboarding (params?: {}): Promise<implicitReturnType>;
    privatePostOrders (params?: {}): Promise<implicitReturnType>;
    privatePostOrdersBatch (params?: {}): Promise<implicitReturnType>;
    privatePostV2Auth (params?: {}): Promise<implicitReturnType>;
    privatePostV2Onboarding (params?: {}): Promise<implicitReturnType>;
    privatePostVaults (params?: {}): Promise<implicitReturnType>;
    privatePostXpTransfer (params?: {}): Promise<implicitReturnType>;
    privatePutAccountProfile (params?: {}): Promise<implicitReturnType>;
    privatePutAccountKeysSubkeysPublicKey (params?: {}): Promise<implicitReturnType>;
    privatePutOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    privateDeleteAccountKeysSubkeysPublicKey (params?: {}): Promise<implicitReturnType>;
    privateDeleteAccountTokensLookupId (params?: {}): Promise<implicitReturnType>;
    privateDeleteAlgoOrdersAlgoId (params?: {}): Promise<implicitReturnType>;
    privateDeleteBlockTradesBlockTradeId (params?: {}): Promise<implicitReturnType>;
    privateDeleteBlockTradesBlockTradeIdOffersOfferId (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrders (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrdersBatch (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrdersByClientIdClientId (params?: {}): Promise<implicitReturnType>;
    privateDeleteOrdersOrderId (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
